<div class="carousel owl-carousel carousel-autoheight">
  <div class="item">
    <div class="banner-search">
      <div class="row">
        <div class="col-lg-6">
          <h2 class="text-banner text-white">
            <span>¡El espacio de tus</span>
            <span>sueños a un solo clic!</span>
          </h2>
          <a
            href="/auth/register"
            class="btn btn-blue mt-1 pt-2 pb-1 px-4 shadow"
          >
            <h5>Registrate aquí</h5>
          </a>
        </div>
      </div>
    </div>
  </div>
  <div class="item">
    <div class="banner-search">
      <div class="row">
        <div class="col-lg-6">
          <h2 class="text-banner text-white">
            <span>¡El espacio de tus</span>
            <span>sueños a un solo clic!</span>
          </h2>
          <a
            href="/auth/register"
            class="btn btn-blue mt-1 pt-2 pb-1 px-4 shadow"
          >
            <h5>Registrate aquí</h5>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- <section class="container">
  <h2 class="font-weight-bold text-center my-3 d-none d-lg-block">Constructoras destacadas</h2>
  <h3 class="font-weight-bold text-center my-3 d-lg-none">Constructoras destacadas</h3>

  <div class="row">
    <div class="col-6 col-lg-2" *ngFor="let company of featuredCompanies; let i = index">
        <div class="featured-companies mb-4 mb-lg-4">
            <img src="./assets/img/constructoras/logo-{{i+1}}.png" alt=""  class="img-fluid object-fit-contain">
        </div>
    </div>
  </div>
</section> -->

<section class="container mb-0">
  <h2 class="font-weight-bold text-center mb-2 d-none d-lg-block">
    Todas las Constructoras
  </h2>
  <h3 class="font-weight-bold text-center mb-2 d-lg-none">
    Todas las Constructoras
  </h3>

  <div class="row">
    <div class="col-lg-4" *ngFor="let company of companies; let i = index">
      <div class="card card-shadow mb-4">
        <div class="row align-items-center">
          <div class="col-5 border-right px-0">
            <div class="text-center pl-3">
              <a href="/constructoras/{{ company.slug }}" class="">
                <img
                  [src]="
                    company.image ||
                    '/assets/img/constructoras/constructoras.jpg'
                  "
                  alt=""
                  class="img-fluid object-fit-contain list-logo p-1"
                />
              </a>
            </div>
          </div>
          <div class="col-7 px-0">
            <div class="text-center pr-3 py-2">
              <a href="/constructoras/{{ company.slug }}" class="">
                <h6 class="text-red font-weight-bold mb-0 text-truncate-3 lh-1">
                  {{ company.name }}
                </h6>
              </a>
              <div class="font-italic font-weight-bold small mb-1">
                {{ company.quantity }} Proyectos de Vivienda
              </div>
              <a
                href="/constructoras/{{ company.slug }}"
                class="btn btn-red btn-rounded text-uppercase small font-italic py-0 px-4 mb-1"
              >
                <small> Ver proyectos </small>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="text-center d-none" *ngIf="companies?.length > 20">
    <a
      class="btn btn-red-outline btn-rounded px-5 font-weight-bold font-italic"
    >
      <span class="px-5"> CARGAR MÁS </span>
    </a>
  </div>

  <div class="text-center mb-3">
    <a
      href="/constructoras/todos-los-proyectos"
      class="btn btn-red text-light px-5 font-weight-bold font-italic"
    >
      <span class="px-5"> VER TODOS LOS PROYECTOS </span>
    </a>
  </div>
</section>
